import Delivery from "features/Delievery/DeliveryList/DeliveryList";

const DeliveryPage: React.FC = () => {
  return <Delivery />;
};

export default DeliveryPage;
